import { Locale } from "./locale.type";

export default {
  title: "Companies",
  locale: {
    english: "Engelska",
    swedish: "Svenska",
  },
  home: {
    home: "Hem",
    welcome: "Välkommen till Companies",
  },
  time: {
    time: "Tid",
    project: "Projekt",
    task: "Uppgift",
    description: "Beskrivning",
    startTime: "Starttid",
    endTime: "Sluttid",
    total: "Totalt",
    today: "Idag",
    start: "Start",
    stop: "Stop",
    edit: "Redigera",
    delete: "Radera",
    add: "Lägg till tid",
    submit: "Spara",
    noTimes: "Inga tider för detta datum.",
    confirmDelete: "Är du säker på att du vill radera denna tidsregistrering?",
    confirmStartDifferentDay:
      "Starttiden är inte på samma dag som datumet. Är du säker på att du vill fortsätta?",
  },
  report: {
    report: "Rapport",
  },
  login: {
    login: "logga in",
    title: "Logga in",
    email: "E-postadress",
    password: "lösenord",
    submit: "Logga in",
    error: "Inloggning misslyckades. Försök igen",
  },
  logout: "Logga ut",
  confirmation: "Är du säker?",
  yes: "Ja",
  no: "Nej",
  ok: "OK",
  cancel: "Avbryt",
  loading: "Läser in...",
  error: {
    code: {
      title: "Server responded with error",
      message: "The following error occurred: {error}",
    },
  },
} as Locale;
